import { useEffect, useState } from "react";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import "./Experience.scss";

function Experience() {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3300);
  }, []);

  return (
    <div className="container experience-page">
      <div className="page">
        <span className="tags top-html">&lt;/html&gt;</span>
        <span className="tags top-tags">&lt;body&gt;</span>

      <div className="text-zone">
        <h1>
          <AnimatedLetters
            letterClass={letterClass}
            strArray={["E", "x", "p", "e", "r", "i", "e", "n", "c", "e"]}
            idx={15}
          />
        </h1>

        {/* Timeline */}
        <div className="timeline-section">
          <div className="timeline-label-text">TIMELINE</div>
          <div className="timeline-visual">
            {/* Quantic Cloud Technologies: May'25 to Aug'25 */}
            <div className="tl-company" style={{ left: '0%', width: '50%' }}>
              <span className="tl-company-name">Quantic Cloud Technologies</span>
              <div className="tl-bar" style={{ background: '#00d2b5' }} />
              <span className="tl-role">SDE Intern</span>
            </div>
            {/* GoBasera: Sep'25 to Nov'25 */}
            <div className="tl-company" style={{ left: '66.67%', width: '33.33%' }}>
              <span className="tl-company-name">GoBasera</span>
              <div className="tl-bar" style={{ background: '#4E8D9C' }} />
              <span className="tl-role">Software Engineering Intern</span>
            </div>
          </div>
          <div className="timeline-years">
            <span style={{ left: '0%' }}>May '25</span>
            <span style={{ left: '50%' }}>Aug '25</span>
            <span style={{ left: '66.67%' }}>Sep '25</span>
            <span style={{ left: '100%' }}>Nov '25</span>
          </div>
        </div>

        {/* Experience Cards */}
        <div className="exp-cards">
          {/* GoBasera */}
          <div className="exp-card">
            <div className="card-header">
              <h3>Software Engineering Intern</h3>
              <span className="card-company">GoBasera</span>
              <span className="card-date">Remote | September 2025 — November 2025</span>
            </div>
            <ul className="card-points">
              <li>Implemented fault-tolerant payment workflows for society maintenance and online dues using Stripe APIs, covering payment intent creation, webhook handling, and retry mechanisms to maintain transaction consistency, achieving ~95% successful online transactions.</li>
              <li>Engineered object-oriented backend services for maintenance billing and complaint management, generating monthly dues per flat, tracking payment status against the payment module, and handling ticket workflows with status-based notifications for residents and admins.</li>
              <li>Enhanced backend maintainability through modular service design, decomposing monolithic logic into 3 independent microservices (payments, onboarding, notifications), improving separation of concerns and debugging.</li>
            </ul>
          </div>

          {/* Quantic Cloud Technologies */}
          <div className="exp-card">
            <div className="card-header">
              <h3>SDE Intern</h3>
              <span className="card-company">Quantic Cloud Technologies</span>
              <span className="card-date">On-site | May 2025 — August 2025</span>
            </div>
            <ul className="card-points">
              <li>Designed backend services for property listing lifecycle management (draft, document, verification, admin approval, live), with 15+ REST APIs for sellers to submit listings and admins to validate property documents before publication.</li>
              <li>Optimized API performance using redis caching, database indexing, and asynchronous processing for heavy operations, reducing latency by ~30% on high-traffic endpoints.</li>
              <li>Refined database schema enhancements and query optimization for high-volume property and transaction data, improving data consistency and read performance under load.</li>
            </ul>
          </div>
        </div>
      </div>

      <span className="tags bottom-tags">
        &lt;/body&gt;
        <br />
        <span className="bottom-tag-html">&lt;/html&gt;</span>
      </span>
      </div>
    </div>
  );
}

export default Experience;
